import { render } from "./CartNav.vue?vue&type=template&id=f3609606&ts=true"
import script from "./CartNav.vue?vue&type=script&lang=ts"
export * from "./CartNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__